// Module
var code = "<template> <require from=\"app/um/components/claim-system-log/claim-system-log\"></require> <compose view-model=\"app/um/components/claim-system-log/claim-system-log\" model.bind=\"modelData\"></compose> </template> ";
// Exports
module.exports = code;